<template>
  <div>
    <Transition>
      <ScrollToTopBtn v-show="scrollBtn"></ScrollToTopBtn
    ></Transition>
    <HeaderMobile v-if="viewStore.isMobile"></HeaderMobile>
    <Header v-else></Header>
    <StoryIntro class="d-none d-sm-block"></StoryIntro>
    <StoryIntroMobile class="d-block d-sm-none"></StoryIntroMobile>
    <Team></Team>
    <Footer></Footer>
  </div>
</template>

<script setup>
import { useViewStore } from "/stores/ViewStore";

const viewStore = useViewStore();
const scrollBtn = ref(false);
const isMobile = ref();

useHead({
  title: "Unsere Story",
  meta: [
    {
      name: "description",
      content:
        "Wir schöpfen unsere Leistung & Qualität aus einem professionellen Pool kreativer Köpfe mit langjähriger Erfahrung. Unser Team besteht aus akademisch ausgebildeten Sound-Engineers, Videographen und Podcast Experten und Expertinnen, die ihr Handwerk verstehen. Unser Service bietet ganzheitliche Unterstützung für die Hörspiel sowie Hörbuch Produktion, inklusive Tonstudio, Postproduktion und Vermarktung. Darüber hinaus unterstützen wir bei der Suche nach professionellen Sprechern, stellen ein hochwertiges Tonstudio für herausragende Soundqualität bereit und kümmern uns um jeden Produktionsschritt für das perfekte Hörbuch oder Hörspiel.",
    },
  ],
});

onMounted(() => {
  window.scrollTo(0, 0);

  if (window.innerWidth < 992) {
    isMobile.value = true;
  }

  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    if (
      document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100
    ) {
      scrollBtn.value = true;
    } else {
      scrollBtn.value = false;
    }
  }
});
</script>
